import API from "../api/axios";

// ─── Get Report Data ───
export const getReport = (type) => {
   return API.get(`/reports?type=${type}`);
};

// ─── Export Report ───
export const exportReport = (type) => {
   return API.get(`/reports/export?type=${type}`, { 
      responseType: "blob" 
   });
};

// ─── Get Report Summary ───
export const getReportSummary = () => {
   return API.get("/reports/summary");
};